import { Message } from "@cohesive/api-client";

/**
 * Keep one row per message id, preferring the copy the stream handler has been
 * writing to. No-op for the common no-duplicate case.
 *
 * Needed because ids are deterministic by design — a harness turn re-read after
 * a reattach re-derives the ids the previous attempt wrote, so the server
 * upserts onto the same rows — while the client's transcript is pages
 * concatenated by React Query. The stream handler's own upsert only reconciles
 * pages that exist when it runs, so a row written into page 0 mid-stream and
 * then returned again inside a later fetched page reaches the render twice and
 * React sees two children with one key.
 *
 * The later entry wins because the flattened array is oldest-first: the stream
 * handler's loops stop at the first page holding the id, so the page-0 copy is
 * the one taking deltas. Its value lands in the earlier entry's slot, which
 * keeps the transcript ordered by the paginated copy rather than by whenever
 * the optimistic insert happened.
 */
export function dedupeMessagesById(messages: Message[]): Message[] {
  const byID = new Map<string, Message>();
  for (const message of messages) {
    byID.set(message.id, message);
  }
  if (byID.size === messages.length) return messages;
  return [...byID.values()];
}
